import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { queryKeys } from './queryClient';
import type { ContractExtractions } from '../types';

/**
 * Query keys for AI document extractions. Nested under the contract detail key, so the
 * document upload and delete mutations (which invalidate every `['contracts']` query) refresh
 * the pending review count too.
 */
export const extractionKeys = {
  byContract: (contractId: string) => [...queryKeys.contracts.detail(contractId), 'extractions'] as const,
};

const fetchContractExtractions = async (contractId: string): Promise<ContractExtractions> => {
  return api.get<ContractExtractions>(`/contracts/${contractId}/extractions`);
};

/**
 * Hook: a contract's extractions and how many wait for review (GET /contracts/{id}/extractions)
 */
export const useContractExtractions = (contractId: string | undefined) => {
  return useQuery({
    queryKey: extractionKeys.byContract(contractId!),
    queryFn: () => fetchContractExtractions(contractId!),
    enabled: !!contractId,
    staleTime: 1000 * 60,
  });
};
